module.exports = __webpack_public_path__ + "img/yiruntong1.c6e72c78.svg";